import { Draft } from 'immer'
import { BlockResponse } from '../types'

type DeleteCustomFieldValueParams = {
  fieldValueId: string
}

export const deleteCustomFieldValue = (
  params: DeleteCustomFieldValueParams
) => {
  return (draftDocument: Draft<BlockResponse>) => {
    if (!draftDocument.data) return draftDocument

    draftDocument.data.details.custom_field_values =
      draftDocument.data.details.custom_field_values.filter(
        (value) => value.data?.id !== params.fieldValueId
      )

    return draftDocument
  }
}
